import { z } from 'zod'

const optionalEnvString = z.preprocess(
  (value) => {
    if (typeof value !== 'string') return value
    const trimmed = value.trim()
    return trimmed.length > 0 ? trimmed : undefined
  },
  z.string().min(1).optional(),
)

const envSchema = z.object({
  VITE_FIREBASE_API_KEY: z.string().min(1),
  VITE_FIREBASE_AUTH_DOMAIN: z.string().min(1),
  VITE_FIREBASE_PROJECT_ID: z.string().min(1),
  VITE_FIREBASE_STORAGE_BUCKET: z.string().min(1),
  VITE_FIREBASE_MESSAGING_SENDER_ID: z.string().min(1),
  VITE_FIREBASE_APP_ID: z.string().min(1),
  VITE_TURNSTILE_SITE_KEY: optionalEnvString,
})

const parsed = envSchema.safeParse(import.meta.env)

if (!parsed.success) {
  console.error(
    '[env] Missing or invalid environment variables:\n',
    parsed.error.flatten().fieldErrors,
  )
  throw new Error('Invalid environment configuration — check .env.local')
}

export const env = parsed.data
